import { Component, Prop, Watch } from 'vue-property-decorator';
import Vue from 'vue';
import { Route } from 'vue-router';

import config, { logo, content } from '../../config';

import WithRender from './header.tpl.html';

@WithRender
@Component({})
class Header extends Vue {

    logo = logo;
    content = content;
    categories: any[] = [];
    mobileNav: boolean = (window.innerWidth < 767) ? false : true;
    searchQuery: string = '';
    
    mounted(){
        this.loadCategories();
    }

    async loadCategories(){
        const infoResult = await fetch(`${config.BaseUrl}/client/client_accounts/info`, {
            credentials: 'include'
        });
        const result = await infoResult.json();
        this.categories = result.categories;
    }

    search(){
        if(this.searchQuery === ''){
            this.$router.push({ name: 'Performers' });
        } else {
            this.$router.push({ name: 'Performers', params: { category: this.$route.params.category }, query: { search: this.searchQuery } });
            this.searchQuery = '';
        }
    }

    @Watch('$route')
    routeChanged(newRoute: Route){
        this.mobileNav = (window.innerWidth < 767) ? false : true;
    }

}

export default Header;




// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/layout/header.ts